import { all, call } from 'redux-saga/effects';

import watchDataElement from './dataElements';
import watchSocialSaga from './social';
import watchDigitainSaga from './fetchDigitainData';
import { watchDataElementsSaga } from './pragmaticLiveWS';
import watchCurrenciesSaga from '@/store/sagas/currencies';

export function* rootStoreSaga() {
  const sagas = [call(watchDataElement), call(watchSocialSaga), call(watchDigitainSaga), call(watchDataElementsSaga)];
  if (window.config && window.config.isSpark === '1') {
    sagas.push(call(watchCurrenciesSaga));
  }

  yield all(sagas);
}
